<script>
    import { createEventDispatcher } from "svelte";
    import Apis from "../../api";
    import Tiempo from "../../componentes/tiempo.svelte";
    import NuevaContrasenia from "./nuveacontrasenia.svelte";

    //export let llave = false;
    let llave = false;

    const dispatch = createEventDispatcher();
    const api = new Apis("usuarios");

    let opcion = "solicitar";

    let dni = "";
    let email = "";
    let displayModal = "none";
    let displayModalProcesando = "none";
    let displayModalRespuesta = "none";
    let displayModalMensaje = "";

    let mostrar_tiempo = false;
    let original = 90;
    let codigo_seguridad;

    let tip_doc = "DN";

    let displayMensajeCodigo = "none";
    let displayBotonVerificarCodigo = "block";

    const tipDoc = [
        { id: "DN", desc: "Documento Nacional de Identidad" },
        { id: "LE", desc: "Libreta de Enrolamiento" },
        { id: "LC", desc: "Libreta Cívica" },
        { id: "PA", desc: "Pasaporte" },
        { id: "CI", desc: "Cédula de Identidad" },
        { id: "CF", desc: "Cédula de Federal" },
    ];

    const hayError = {
        display: "none",
        mensaje: "",
        reset() {
            hayError.display = "none";
            hayError.mensaje = "";
        },
    };

    async function recuperarContrasenia() {
        displayModalProcesando = "block";
        displayModal = "block";
        const param = new FormData();
        param.append("accion", "recuperarContrasenia");
        param.append("dni", tip_doc + " " + dni.trim());
        param.append("email", email);

        const json = await api.procesar(param);

        if (json.error) {
            //alert('error');
            //console.log(json);

            displayModalProcesando = "none";
            displayModal = "none";
            hayError.display = "block";
            hayError.mensaje = json.mensaje;
        } else {
            //alert('ok');
            //console.log(json);
            original = 90;
            mostrar_tiempo = true;
            displayModalMensaje = json.mensaje;
            displayModalProcesando = "none";
            displayModalRespuesta = "block";
        }
    }

    async function verificar_codigo() {
        const param = new FormData();
        param.append("accion", "verificarcodigo");
        param.append("codigo", codigo_seguridad);
        param.append("email", email);

        const json = await api.procesar(param);

        if (json.error) {
            displayMensajeCodigo = "block";
        } else {
            //console.log(json);
            llave = json.llave;
            opcion = "crear_contrasenia";
            //dispatch("crear_contrasenia", { llave });
        }
    }
</script>

{#if opcion == "solicitar"}
    <div class="w3-padding w3-border w3-round">
        <h4>Crear o modificar tu contraseña..</h4>
        <div on:click={() => hayError.reset()}>
            <div class="w3-section">
                <label for="clave">Tipo de Documento:</label>
                <select class="w3-input w3-light-grey" bind:value={tip_doc}>
                    {#each tipDoc as tido}
                        <option value={tido.id}>{tido.desc}</option>
                    {/each}
                </select>
            </div>
            <div class="w3-section">
                <label for="clave">Número de Documento:</label>
                <input
                    name="dni"
                    type="text"
                    class="w3-input w3-light-grey"
                    bind:value={dni}
                />
            </div>
            <div class="w3-section">
                <label for="email">eMail:</label>
                <input
                    name="email"
                    type="email"
                    class="w3-input w3-light-grey"
                    bind:value={email}
                />
            </div>

            <div class="w3-section">
                <button
                    class="w3-btn w3-blue w3-round"
                    on:click={recuperarContrasenia}>Continuar</button
                >
                <button
                    class="w3-btn w3-red w3-round w3-right"
                    on:click={() => dispatch("cancelar")}>Cancelar</button
                >
            </div>
        </div>
        <div class="w3-section" style="display:{hayError.display}">
            <div class="w3-padding w3-yellow w3-text-red">
                {@html hayError.mensaje}
            </div>
        </div>
    </div>

    <div class="w3-modal" style="display:{displayModal}">
        <div class="w3-modal-content w3-card-4" style="margin-top:30px">
            <header class="w3-container w3-blue">
                <h3>Crear o modificar tu contraseña</h3>
            </header>
            <div class="w3-container" style="display:{displayModalRespuesta}">
                <div class="w3-section">
                    <p class="w3-medium">{@html displayModalMensaje}</p>
                </div>
                <div class="w3-row-padding">
                    <div class="w3-half w3-center">
                        <input
                            type="text"
                            maxlength="6"
                            placeholder="código"
                            class="w3-input w3-round w3-border w3-xxlarge"
                            style="text-align: center; height:95px"
                            on:focus={() => (displayMensajeCodigo = "none")}
                            bind:value={codigo_seguridad}
                        />
                    </div>
                    <div class="w3-half">
                        <div class="w3-border w3-round w3-center">
                            {#if mostrar_tiempo}
                                <Tiempo
                                    {original}
                                    on:finalizo={() => dispatch("cancelar")}
                                    class="w3-border w3-round"
                                />
                            {/if}
                        </div>
                    </div>
                </div>

                <div class="w3-section">
                    <button
                        class="w3-btn w3-medium w3-blue w3-round"
                        on:click={verificar_codigo}>Continuar</button
                    >
                    <button
                        class="w3-btn w3-medium w3-red w3-round w3-right"
                        on:click={() => {
                            /* displayModalRespuesta = "none";
                        displayModal = "none";
                        original = 120;
                        mostrar_tiempo = false; */
                            dispatch("cancelar");
                        }}>Cancelar</button
                    >
                </div>

                <div class="w3-section" style="display:{displayMensajeCodigo}">
                    <div class="w3-padding w3-yellow w3-text-red w3-center">
                        No se pudo verificar el código. Intente más tarde.
                    </div>
                </div>
            </div>
            <div class="w3-container" style="display:{displayModalProcesando}">
                <div class="w3-section">
                    <p class="w3-medium">Procesando...</p>
                </div>
            </div>
        </div>
    </div>
{/if}

{#if opcion =="crear_contrasenia"}
    <!-- <CrearContrasenia on:cancelar={() => (opcion = 1)} /> -->
    <NuevaContrasenia  {llave} on:volver={() => dispatch("cancelar")}  />
{/if}